"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagOption = exports.FeatureFlag = exports.FeatureFlagProvider = exports.FeatureFlagProviderContext = void 0;
const tslib_1 = require("tslib");
const LDClient = tslib_1.__importStar(require("launchdarkly-js-client-sdk"));
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
exports.FeatureFlagProviderContext = react_1.createContext({
    state: 'LOADING',
});
const FeatureFlagProvider = ({ clientApiKey, userIdentifier, companyId, children }) => {
    const [flags, setFlags] = react_1.useState({});
    const [ldClient, setLdClient] = react_1.useState();
    const [clientState, setClientState] = react_1.useState('LOADING');
    react_1.useEffect(() => {
        const userIdBase = {
            key: userIdentifier ? userIdentifier : 'notLoggedIn',
            kind: 'user',
        };
        const client = LDClient.initialize(clientApiKey, companyId ? { ...userIdBase, companyId: companyId } : userIdBase);
        setLdClient(client);
        return () => {
            client.close();
        };
    }, [clientApiKey, userIdentifier, companyId]);
    react_1.useEffect(() => {
        ldClient === null || ldClient === void 0 ? void 0 : ldClient.waitForInitialization().then(() => {
            setFlags(ldClient.allFlags());
            setClientState('READY');
        }).catch((e) => {
            console.error('Failed to connect to launch darkly', e);
            setClientState('ERROR');
        });
    }, [ldClient]);
    react_1.useEffect(() => {
        if (ldClient && clientState === 'READY') {
            const onChange = (changes) => {
                const newValues = {};
                Object.keys(changes).forEach((key) => {
                    newValues[key] = changes[key].current;
                });
                setFlags({ ...flags, ...newValues });
            };
            ldClient.on('change', onChange);
            return () => {
                ldClient.off('change', onChange);
            };
        }
    }, [ldClient, flags, clientState]);
    const getFlag = clientState === 'LOADING'
        ? undefined
        : (flagName) => {
            var _a;
            return (_a = flags[flagName]) !== null && _a !== void 0 ? _a : 'missing';
        };
    return (React.createElement(exports.FeatureFlagProviderContext.Provider, { value: { getFlag, state: clientState } }, children));
};
exports.FeatureFlagProvider = FeatureFlagProvider;
const FeatureFlagValueContext = react_1.createContext({
    flagValue: '',
});
const FeatureFlag = ({ flagName, children, fallbackComponent, errorComponent, loadingComponent, }) => {
    var _a;
    const { getFlag, state } = react_1.useContext(exports.FeatureFlagProviderContext);
    const flagValue = (_a = getFlag === null || getFlag === void 0 ? void 0 : getFlag(flagName)) !== null && _a !== void 0 ? _a : 'missing';
    const wrappedChild = (React.createElement(FeatureFlagValueContext.Provider, { value: { flagValue } }, children));
    const firstDefined = (...components) => {
        for (const component of components) {
            if (component !== undefined) {
                return React.createElement(React.Fragment, null, component);
            }
        }
        return React.createElement(React.Fragment, null);
    };
    switch (state) {
        case 'LOADING':
            return firstDefined(loadingComponent, fallbackComponent, wrappedChild);
        case 'ERROR':
            return firstDefined(errorComponent, fallbackComponent, wrappedChild);
        case 'READY':
            if (flagValue === 'missing' && fallbackComponent) {
                return React.createElement(React.Fragment, null, fallbackComponent);
            }
            else {
                return wrappedChild;
            }
    }
};
exports.FeatureFlag = FeatureFlag;
const FlagOption = ({ flagValue, children, }) => {
    const { flagValue: value } = react_1.useContext(FeatureFlagValueContext);
    if (flagValue === value) {
        return React.createElement(React.Fragment, null, children);
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
exports.FlagOption = FlagOption;
